<template>
  <div>
    <div>
      <h6 class="text-base inline-block">Details</h6>
      &nbsp;
      <a v-if="detailOptions.length > 0" role="button" class="inline-block" @click="loadDetails">
        Load details
      </a>
    </div>

    <template v-if="showDetails">
      <ul class="grid gap-1 grid-cols-3 mt-4">
        <li
          v-for="details in detailOptions"
          :key="details.uuid"
          class="bg-white rounded p-4 border hover:border-gray-600 hover:bg-gray-100"
          @click="setDetails(details)"
        >
          <ul>
            <li>{{ details.businessName }}</li>
            <li>{{ details.businessAddress }}</li>
            <li>{{ details.number }}</li>
            <li>{{ details.office }}</li>
          </ul>
        </li>
      </ul>
    </template>

    <ValidationProvider
      rules="required"
      name="recipientName"
      tag="div"
      vid="recipientName"
      class="w-1/2 mt-8"
    >
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Name </BaseFormLabel>
          <BaseFormInput v-model="computedName" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider
      rules="required"
      name="recipientAddress"
      tag="div"
      vid="recipientAddress"
      class="w-1/3 mt-8"
    >
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Address </BaseFormLabel>
          <BaseFormTextarea v-model="computedAddress" rows="3" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider
      rules="required"
      name="recipientVatNumber"
      tag="div"
      vid="recipientVatNumber"
      class="w-64 mt-8"
    >
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Registration number </BaseFormLabel>
          <BaseFormInput v-model="computedVatNumber" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider
      rules="required"
      name="recipientVatOffice"
      tag="div"
      vid="recipientVatOffice"
      class="w-64 mt-8"
    >
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Registration office </BaseFormLabel>
          <BaseFormInput v-model="computedVatOffice" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    accountUuid: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    address: {
      type: String,
      default: '',
    },
    vatNumber: {
      type: String,
      default: '',
    },
    vatOffice: {
      type: String,
      default: '',
    },
    detailOptions: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },

  data() {
    return {
      showDetails: false,
    };
  },

  computed: {
    computedName: {
      get() {
        return this.name;
      },
      set(value) {
        this.$emit('update:name', value);
      },
    },
    computedAddress: {
      get() {
        return this.address;
      },
      set(value) {
        this.$emit('update:address', value);
      },
    },
    computedVatNumber: {
      get() {
        return this.vatNumber;
      },
      set(value) {
        this.$emit('update:vat-number', value);
      },
    },
    computedVatOffice: {
      get() {
        return this.vatOffice;
      },
      set(value) {
        this.$emit('update:vat-office', value);
      },
    },
  },

  methods: {
    loadDetails() {
      this.showDetails = true;
    },

    setDetails(details) {
      this.$emit('update:name', details.businessName);
      this.$emit('update:address', details.businessAddress);
      this.$emit('update:vat-number', details.number);
      this.$emit('update:vat-office', details.office);

      this.showDetails = false;
    },
  },
};
</script>
